import * as qiniu from "qiniu-js";
/* 生成当前时间戳对应的62进制形式短链接 */

export const mixinUpload = {
  methods: {
    // 获取token
    getTokenMessage(file, cb) {
      this.$reqGet("api/g/v1/qiniu/front-token").then(res => {
        if (res.data.status == 200) {
          let data = res.data.data;
          this.domain = data.domain;
          this.token = data.uptoken;
          this.upload(file, cb);
        }
      });
    },
    // 图片上传
    upload(upImg, cb) {
      var that = this;
      let maxsize = 5 * 1024 * 1024;
      if (upImg.size > maxsize) {
        Toast("图片大小不能超过5M！");
        return;
      }
      let key = this.shorten() + upImg.name.substr(upImg.name.lastIndexOf("."));
      let task = {
        complete: false,
        size: upImg.size,
        name: upImg.name,
        type: upImg.type,
        url: ""
      };
      task.subscription = qiniu.upload(upImg, key, this.token).subscribe({
        next(res) {
          task.total = res.total;
        },
        error(err) {
          Toast(err);
        },
        complete(res) {
          task.complete = true;
          cb(that.domain + res.key);
        }
      });
    },
    shorten() {
      var DIGITS =
        "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
      var seq = new Date().getTime();
      var len = DIGITS.length;
      var arr = [];
      do {
        arr.unshift(DIGITS.charAt(seq % len));
        seq = parseInt(seq / len);
      } while (seq !== 0);
      return arr.join("");
    }
  }
};



// WEBPACK FOOTER //
// ./src/assets/js/imgUpload.js